import { Locales } from "../enums/locales";
export const normalizeContentLocale = (locale) => {
    if (locale === Locales.FR) {
        return Locales.FR;
    }
    if (locale === Locales.ES) {
        return Locales.ES;
    }
    return Locales.EN;
};
const EMAIL_EMPTY_LINE = "<p><br></p>";
export const LocaleContent = {
    DonationTypeLabel: {
        [Locales.EN]: "Donation",
        [Locales.FR]: "Don",
        [Locales.ES]: "Donación",
    },
    DonationTypeLabelLowercase: {
        [Locales.EN]: "donation",
        [Locales.FR]: "don",
        [Locales.ES]: "donación",
    },
    TicketTypeLabel: {
        [Locales.EN]: "Ticket",
        [Locales.FR]: "Billet",
        [Locales.ES]: "Entrada",
    },
    NameQuestionLabel: {
        [Locales.EN]: "Name",
        [Locales.FR]: "Nom",
        [Locales.ES]: "Nombre",
    },
    ReferralLabel: {
        [Locales.EN]: "Referrals",
        [Locales.FR]: "Parrainages",
        [Locales.ES]: "Referidos",
    },
    ChatGreeting: {
        [Locales.EN]: "Hi",
        [Locales.FR]: "Bonjour",
        [Locales.ES]: "Hola",
    },
    LanguageLabel: {
        [Locales.EN]: "English",
        [Locales.FR]: "French (Canadian)",
        [Locales.ES]: "Spanish",
    },
    ReminderEmailPrefix: {
        [Locales.EN]: "[Reminder] ",
        [Locales.FR]: "[Rappel] ",
        [Locales.ES]: "[Recordatorio] ",
    },
    FollowUpPrefix: {
        [Locales.EN]: "Follow up:",
        [Locales.FR]: "Suivi :",
        [Locales.ES]: "Seguimiento:",
    },
    ReceiptCanceledLabel: {
        [Locales.EN]: "Canceled",
        [Locales.FR]: "Annulé",
        [Locales.ES]: "Cancelado",
    },
    MembershipExpirationSubject: {
        [Locales.EN]: "Your membership expires in a month",
        [Locales.FR]: "Votre adhésion expire dans un mois",
        [Locales.ES]: "Tu membresía expira en un mes",
    },
    FakeReceiptAddress: {
        [Locales.EN]: "1 Down Avenue",
        [Locales.FR]: "1 rue Notre-Dame Est",
        [Locales.ES]: "Calle Falsa 123",
    },
    YesLabel: {
        [Locales.EN]: "Yes",
        [Locales.FR]: "Oui",
        [Locales.ES]: "Sí",
    },
    NoLabel: {
        [Locales.EN]: "No",
        [Locales.FR]: "Non",
        [Locales.ES]: "No",
    },
    UntitledQuestionLabel: {
        [Locales.EN]: "Untitled question",
        [Locales.FR]: "Question sans titre",
        [Locales.ES]: "Pregunta sin título",
    },
    UntitledChoiceLabel: {
        [Locales.EN]: "Untitled choice",
        [Locales.FR]: "Choix sans titre",
        [Locales.ES]: "Opción sin título",
    },
    UntitledTicketLabel: {
        [Locales.EN]: "Untitled ticket",
        [Locales.FR]: "Billet sans titre",
        [Locales.ES]: "Entrada sin título",
    },
    UntitledMembershipLabel: {
        [Locales.EN]: "Untitled membership",
        [Locales.FR]: "Adhésion sans titre",
        [Locales.ES]: "Membresía sin título",
    },
    UntitledItemLabel: {
        [Locales.EN]: "Untitled item",
        [Locales.FR]: "Article sans titre",
        [Locales.ES]: "Artículo sin título",
    },
    UntitledCampaignLabel: {
        [Locales.EN]: "Untitled campaign",
        [Locales.FR]: "Campagne sans titre",
        [Locales.ES]: "Campaña sin título",
    },
    DefaultOrganizationName: {
        [Locales.EN]: "My Organization",
        [Locales.FR]: "Mon Organisation",
        [Locales.ES]: "Mi Organización",
    },
    GivingTuesdayContent: {
        [Locales.EN]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Dear <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">First name</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">We are beyond grateful for your generous support this giving season! Because of donors like you, we are able to come together as a community and make a significant impact throughout this season of giving.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Your donation is already making a difference, helping us work towards our mission. We couldn\'t do this without you!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Every single gift counts, and your kindness is helping us take meaningful steps toward a brighter, more hopeful future. Thank you for believing in our cause and for standing with us during this giving season.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">We\'ll be sure to keep you updated on the positive change you\'ve helped create!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">All the best,<br />{userName}<br />{orgName}</p>',
            emailObject: "Thank You for Your Incredible Support this giving season!",
        },
        [Locales.FR]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Cher <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">Prénom</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Nous sommes extrêmement reconnaissants de votre soutien généreux cette saison des dons ! Grâce à des donateurs comme vous, nous pouvons nous rassembler en tant que communauté et avoir un impact significatif tout au long de cette saison de générosité.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Votre don fait déjà la différence et nous aide à accomplir notre mission. Nous ne pourrions pas faire cela sans vous !</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Chaque don compte, et votre gentillesse nous aide à prendre des mesures significatives pour un avenir meilleur et plein d\'espoir. Nous vous remercions de croire en notre cause et de vous tenir à nos côtés pendant cette saison des dons.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Nous ne manquerons pas de vous tenir au courant des changements positifs que vous avez contribué à créer !</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Tous mes vœux de réussite,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">{userName}</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">{orgName}</p>',
            emailObject: "Merci pour votre incroyable soutien cette saison des dons !",
        },
        [Locales.ES]: {
            emailContent: '<p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Estimado <span contenteditable="false" data-custom-variable="{{firstname}}" fr-original-class="fr-deletable styled-tag-chip">Nombre</span>,</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">¡Estamos extremadamente agradecidos por tu generoso apoyo esta temporada de donaciones! Gracias a donantes como tú, podemos unirnos como comunidad y tener un impacto significativo durante toda esta temporada de generosidad.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Tu donación ya está marcando la diferencia y nos ayuda a cumplir nuestra misión. ¡No podríamos hacer esto sin ti!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Cada donación cuenta, y tu amabilidad nos ayuda a dar pasos significativos hacia un futuro más brillante y esperanzador. Gracias por creer en nuestra causa y por apoyarnos durante esta temporada de donaciones.</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">¡Nos aseguraremos de mantenerte informado sobre los cambios positivos que has ayudado a crear!</p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)"><br /></p><p style="width:100%;margin-top:0px;margin-bottom:0px;box-sizing:inherit;color:rgb(0, 0, 0)">Todos mis mejores deseos,<br />{userName}<br />{orgName}</p>',
            emailObject: "¡Gracias por tu increíble apoyo esta temporada de donaciones!",
        },
    },
    StytchMagicLinkLoginTemplateId: {
        [Locales.EN]: "membership_magical_link_login",
        [Locales.FR]: "membership_magical_link_login_fr",
        [Locales.ES]: "membership_magical_link_login",
    },
    StytchMagicLinkBidderLoginTemplateId: {
        [Locales.EN]: "bidder_magical_link_login",
        [Locales.FR]: "bidder_magical_link_login_fr",
        [Locales.ES]: "bidder_magical_link_login",
    },
    StytchMagicLinkRecurringDonationLoginTemplateId: {
        [Locales.EN]: "recurring_donation_magical_link_login_en",
        [Locales.FR]: "recurring_donation_magical_link_login_fr",
        [Locales.ES]: "recurring_donation_magical_link_login_en",
    },
    StytchEmailOtpBidderTemplateId: {
        [Locales.EN]: "bidder_email_otp",
        [Locales.FR]: "bidder_email_otp_fr",
        [Locales.ES]: "bidder_email_otp",
    },
    StytchForgotPasswordTemplateId: {
        [Locales.EN]: "forgot_password_en",
        [Locales.FR]: "forgot_password_fr",
        [Locales.ES]: "forgot_password_en",
    },
    StytchCreatePasswordTemplateId: {
        [Locales.EN]: "create_password_en",
        [Locales.FR]: "create_password_fr",
        [Locales.ES]: "create_password_es",
    },
    DonationAutoRenewalSubject: {
        [Locales.EN]: "Your recurring donation renews soon ✨",
        [Locales.FR]: "Votre don récurrent se renouvelle bientôt ✨",
        [Locales.ES]: "Tu donación recurrente se renueva pronto ✨",
    },
    DonationAutoRenewalBody: {
        [Locales.EN]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Hi ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Your recurring donation to ${orgName} will be charged on ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Amount:</strong> ${renewalAmount}<br/><strong>Payment method:</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Thank you for your continued support.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
        [Locales.FR]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Bonjour ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Votre don récurrent à ${orgName} sera prélevé le ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Montant :</strong> ${renewalAmount}<br/><strong>Méthode de paiement :</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Merci pour votre soutien continu.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
        [Locales.ES]: ({ orgName, firstName, renewalDate, renewalAmount, paymentMethod, signature, }) => `<p>Hola ${firstName},</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Tu donación recurrente a ${orgName} se cobrará el ${renewalDate}.</p>` +
            EMAIL_EMPTY_LINE +
            `<p><strong>Monto:</strong> ${renewalAmount}<br/><strong>Método de pago:</strong> ${paymentMethod}</p>` +
            EMAIL_EMPTY_LINE +
            `<p>Gracias por tu apoyo continuo.</p>` +
            EMAIL_EMPTY_LINE +
            signature,
    },
    PaymentNotificationBody: {
        [Locales.EN]: ({ name, formattedAmount }) => `${name} made a ${formattedAmount} payment to your cause`,
        [Locales.FR]: ({ name, formattedAmount }) => `${name} a fait un paiement de ${formattedAmount} à votre cause`,
        [Locales.ES]: ({ name, formattedAmount }) => `${name} hizo un pago de ${formattedAmount} a tu causa`,
    },
    DonationFormHeaderMeta: {
        [Locales.EN]: ({ orgName, formTitle }) => ({
            metaTitle: `Donate to ${orgName} | Zeffy`,
            metaDescription: `Help ${orgName} raise funds for ${formTitle}. Make a donation on Zeffy, and ensure 100% of your donation goes to fund ${orgName}’s mission.`,
        }),
        [Locales.FR]: ({ orgName, formTitle }) => ({
            metaTitle: `Faites un don à ${orgName} | Zeffy`,
            metaDescription: `Aidez ${orgName} à collecter des fonds pour ${formTitle}. Faites un don sur Zeffy et assurez-vous que 100 % de votre don soit consacré à la mission de ${orgName}.`,
        }),
        [Locales.ES]: ({ orgName, formTitle }) => ({
            metaTitle: `Dona a ${orgName} | Zeffy`,
            metaDescription: `Ayuda a ${orgName} a recaudar fondos para ${formTitle}. Haz una donación en Zeffy y asegúrate de que el 100% de tu donación se destine a la misión de ${orgName}.`,
        }),
    },
    P2pHeaderMeta: {
        [Locales.EN]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Donate to ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Help ${orgName} raise funds for ${campaignTitle}. Donate securely on Zeffy — 100% of your donation goes to the nonprofit.`,
        }),
        [Locales.FR]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Faites un don à ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Aidez ${orgName} à collecter des fonds pour ${campaignTitle}. Faites un don sécurisé sur Zeffy - 100 % de votre don est reversé à l'association.`,
        }),
        [Locales.ES]: ({ orgName, campaignTitle }) => ({
            metaTitle: `Dona a ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `Ayuda a ${orgName} a recaudar fondos para ${campaignTitle}. Dona de forma segura en Zeffy - el 100 % de tu donación se destina a la organización sin fines de lucro.`,
        }),
    },
    TeamHeaderMeta: {
        [Locales.EN]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Support ${teamName} for ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} is fundraising for ${orgName}’s ${campaignTitle}. Make a donation on Zeffy and support their cause — 100% of your gift goes to the nonprofit.`,
        }),
        [Locales.FR]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Soutenez ${teamName} pour ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} collecte des fonds pour ${campaignTitle} de ${orgName}. Faites un don sur Zeffy et soutenez sa cause - 100 % de votre don est reversé à l'association à but non lucratif.`,
        }),
        [Locales.ES]: ({ orgName, teamName, campaignTitle, }) => ({
            metaTitle: `Apoya a ${teamName} en ${campaignTitle} | ${orgName} | Zeffy`,
            metaDescription: `${teamName} está recaudando fondos para ${campaignTitle} de ${orgName}. Haz una donación en Zeffy y apoya su causa - el 100% de su donación se destina a la organización sin fines de lucro.`,
        }),
    },
    OrganizationPageHeaderMeta: {
        [Locales.EN]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Support ${orgName}. Learn more about their mission and make a donation on Zeffy — 100% of your donation goes to the nonprofit.`,
        }),
        [Locales.FR]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Soutenez ${orgName}. Découvrez leur mission et faites un don sur Zeffy - 100 % de votre don est reversé à l'association.`,
        }),
        [Locales.ES]: ({ orgName }) => ({
            metaTitle: `${orgName} | Zeffy`,
            metaDescription: `Apoya a ${orgName}. Conoce más sobre su misión y haz una donación en Zeffy - el 100% de tu donación se destina a la organización sin fines de lucro.`,
        }),
    },
    TicketingEventHeaderMeta: {
        [Locales.EN]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` at ${address}` : "";
            const startDatePart = startDate ? ` on ${startDate}` : "";
            const addressDescriptionPart = address ? ` at ${address}` : "";
            return {
                metaTitle: `${title} - Charity event${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Join us for ${title}, a fundraising event hosted by ${orgName}${startDatePart}${addressDescriptionPart}. Buy your ticket with Zeffy — 100% of proceeds go to ${orgName}.`,
            };
        },
        [Locales.FR]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` à ${address}` : "";
            const startDatePart = startDate ? ` le ${startDate}` : "";
            const addressDescriptionPart = address ? ` à ${address}` : "";
            return {
                metaTitle: `${title} - Événement caritatif${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Rejoignez-nous pour ${title}, un événement de collecte de fonds organisé par ${orgName}${startDatePart}${addressDescriptionPart}. Achetez votre billet avec Zeffy — 100 % des bénéfices seront reversées à ${orgName}.`,
            };
        },
        [Locales.ES]: ({ title, orgName, address, startDate, }) => {
            const addressTitlePart = address ? ` en ${address}` : "";
            const startDatePart = startDate ? ` el ${startDate}` : "";
            const addressDescriptionPart = address ? ` en ${address}` : "";
            return {
                metaTitle: `${title} - Evento benéfico${addressTitlePart} | ${orgName} | Zeffy`,
                metaDescription: `Únete a nosotros en ${title}, un evento benéfico organizado por ${orgName}${startDatePart}${addressDescriptionPart}. Compra tu entrada con Zeffy - 100% de las ganancias van a ${orgName}.`,
            };
        },
    },
    TicketingMembershipHeaderMeta: {
        [Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Make a payment to ${title}. Zeffy is 100% free - 100% of your payment goes directly to ${orgName}.`,
        }),
        [Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Effectuez un paiement à ${title}. Zeffy est 100 % gratuit  - 100 % de votre paiement est reversé directement à ${orgName}.`,
        }),
        [Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Realiza un pago a ${title}. Zeffy es 100 % gratuito: el 100 % de tu pago se destina directamente a ${orgName}.`,
        }),
    },
    TicketingLotteryHeaderMeta: {
        [Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Enter ${orgName}'s fundraising raffle to support their mission. Raffle tickets available on Zeffy — 100% of proceeds go to the nonprofit.`,
        }),
        [Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participez à la tombola de ${orgName} pour soutenir sa mission. Billets disponibles sur Zeffy — 100 % des bénéfices reversés à l'association.`,
        }),
        [Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participa en la rifa de recaudación de fondos de ${orgName} para apoyar su misión. Boletos de la rifa disponibles en Zeffy - el 100 % de las ganancias se destina a la organización sin fines de lucro.`,
        }),
    },
    TicketingSweepstakesHeaderMeta: {
        [Locales.EN]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Enter ${orgName}'s sweepstakes to support their mission. No donation is necessary to enter.`,
        }),
        [Locales.FR]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participez au concours promotionnel de ${orgName} pour soutenir sa mission. Aucun don n'est requis pour participer.`,
        }),
        [Locales.ES]: ({ title, orgName }) => ({
            metaTitle: `${title} | ${orgName} | Zeffy`,
            metaDescription: `Participa en el sorteo promocional de ${orgName} para apoyar su misión. No es necesario donar para participar.`,
        }),
    },
    TicketingAuctionHeaderMeta: {
        [Locales.EN]: ({ orgName }) => ({
            metaTitle: `Silent Auction – ${orgName} | Zeffy`,
            metaDescription: `Bid to support ${orgName}'s silent auction. Hosted on Zeffy — the only 100% free silent auction platform for nonprofits.`,
        }),
        [Locales.FR]: ({ orgName }) => ({
            metaTitle: `Vente aux enchères silencieuse – ${orgName} | Zeffy`,
            metaDescription: `Enchérissez pour soutenir la vente aux enchères silencieuse de ${orgName}. Hébergée sur Zeffy, la seule plateforme de vente aux enchères silencieuse 100 % gratuite pour les associations.`,
        }),
        [Locales.ES]: ({ orgName }) => ({
            metaTitle: `Subasta silenciosa – ${orgName} | Zeffy`,
            metaDescription: `Puja para apoyar la subasta silenciosa de ${orgName}. Organizada por Zeffy, la única plataforma de subastas silenciosas 100 % gratuita para organizaciones sin fines de lucro.`,
        }),
    },
    TicketingShopHeaderMeta: {
        [Locales.EN]: ({ orgName }) => ({
            metaTitle: `${orgName}'s Online Store | Zeffy`,
            metaDescription: `Browse ${orgName}'s online store and support their mission with every purchase. Powered by Zeffy — 100% of proceeds go to the nonprofit.`,
        }),
        [Locales.FR]: ({ orgName }) => ({
            metaTitle: `Boutique en ligne de ${orgName} | Zeffy`,
            metaDescription: `Parcourez la boutique en ligne de ${orgName} et soutenez sa mission à chaque achat. Propulsé par Zeffy — 100 % des bénéfices reversés à l'association.`,
        }),
        [Locales.ES]: ({ orgName }) => ({
            metaTitle: `Tienda en línea de ${orgName} | Zeffy`,
            metaDescription: `Explora la tienda en línea de ${orgName} y apoya su misión con cada compra. Impulsado por Zeffy - el 100 % de las ganancias se destina a la organización sin fines de lucro.`,
        }),
    },
};
